import { B } from '../../constants/brand';

// Harvus Investment mark — a bracketed serif capital "I" in brand teal.
// `color` defaults to the brand teal so the mark matches the source artwork;
// callers on light backgrounds may pass a darker color for legibility.
export const HarvusLogo = ({ height = 28, color = B.teal }) => (
  <svg height={height} viewBox="0 0 62 100" xmlns="http://www.w3.org/2000/svg">
    <path
      fill={color}
      d="M0,0 L62,0 L62,15 Q40,15 40,27 L40,73 Q40,85 62,85 L62,100 L0,100 L0,85 Q22,85 22,73 L22,27 Q22,15 0,15 Z"
    />
  </svg>
);
